// GENERATED FILE, PLEASE DO NOT EDIT
export var ModalActionButtonsInline = 8;
export var SmallPageMargin = 16;